// Angular modules
import { Component }        from '@angular/core';
import { EventEmitter }     from '@angular/core';
import { Input }            from '@angular/core';
import { OnInit }           from '@angular/core';
import { Output }           from '@angular/core';
import { AbstractControl }  from '@angular/forms';
import { FormControl }      from '@angular/forms';
import { FormGroup }        from '@angular/forms';

// External modules
import { DateIntervalUtil } from '../filter-engine/date-field/date-interval-field.util';

@Component({
  selector    : 'app-date-input',
  templateUrl : './date-input.component.html',
  styleUrls   : ['./date-input.component.scss']
})
export class DateInputComponent implements OnInit
{
  dateForm   : FormGroup;
  allHours   : Array<number> = [];
  allMinutes : Array<number> = [];
  defValue   : Date = null;

  @Input() disabled : boolean;

  @Output() changed         : EventEmitter<Date> = new EventEmitter<Date>();
  @Output() selectionChange : EventEmitter<Date> = new EventEmitter<Date>();

  constructor() {}

  ngOnInit()
  {
    this.allHours = DateIntervalUtil.getArrayOfConsecutiveNumbers(0, 23);
    this.allMinutes = DateIntervalUtil.getArrayOfConsecutiveNumbers(0, 59);

    this.dateForm = new FormGroup({
      date    : new FormControl(this.defaultValue ?? null, []),
      hours   : new FormControl(this.defaultValue.getUTCHours() ?? 0, []),
      minutes : new FormControl(this.defaultValue.getUTCMinutes() ?? 0, []),
    });

    if (this.disabled) {
      this.dateForm.disable();
    } else {
      this.dateForm.valueChanges.subscribe(_ => {
        const val = this.date.value as Date;
        if (val && val !== null) {
          const date = new Date(Date.UTC(
            val.getFullYear(),
            val.getMonth(), val.getDate(),
            this.hours.value,
            this.minutes.value,
            this.defaultValue.getSeconds() ?? 0,
            0));
          this.changed.emit(date);
          this.selectionChange.emit(date);
        }
      });
    }
  }

  reset(): void {
    if (this.dateForm) {
      this.dateForm.reset();
      this.date.reset(this.defaultValue ?? null);
      this.hours.reset(this.defaultValue.getUTCHours() ?? 0);
      this.minutes.reset(this.defaultValue.getUTCMinutes() ?? 0);
      this.changed.emit(this.defaultValue);
      this.selectionChange.emit(this.defaultValue);
    }
  }

  @Input()
  public get defaultValue(): Date {
    return this.defValue;
  }

  public set defaultValue(value: Date) {
    this.defValue = value;
    this.reset();
  }

  get date(): AbstractControl {
    return this.dateForm.get('date');
  }

  get hours(): AbstractControl {
    return this.dateForm.get('hours');
  }

  get minutes(): AbstractControl {
    return this.dateForm.get('minutes');
  }
}
